import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'apps/property-sell/src/environments/environment';
import { from, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
    removeTrailingSlash,
    addTrailingSlash
} from '@classifieds-sell/shared';
import { UserFacade } from '@classifieds-sell/state';

@Component({
    selector: 'property-header',
    templateUrl: './property-header.component.html',
    standalone: false
})
export class PropertyHeaderComponent implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    tradeMeUrl = `${removeTrailingSlash(environment.trademeUrl)}`;
    myTradeMeUrl = `${addTrailingSlash(
        environment.trademeUrl
    )}MyTradeMe/Default.aspx`;
    myPhotoUrl: string;

    constructor(private _userFacade: UserFacade) {}

    ngOnDestroy(): void {
        this._destroyed$.next();
    }

    ngOnInit(): void {
        from(this._userFacade.userDetails$)
            .pipe(takeUntil(this._destroyed$))
            .subscribe((ud) => {
                this.myPhotoUrl =
                    ud.memberSummary?.memberProfile?.photo ||
                    'assets/trademe-core-ui/kiwi130-v2.gif';
            });
    }
}
